/* GeneratedContentHash: 3e2f5986928234e0032e6d6aa2113ef73c7ccbd14e320eb7af9c0b0667120c64 */
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/

export const PLACEMENT_ID = 'app-switcher-upgrade-section';
